export enum EnvironmentNames {
  CNCF = 'cncf',
  EME = 'eme',
  IGF = 'igf',
  SWISS = 'swiss',
  GLF = 'glf',
  SINNGEBER = 'sinngeber',
  TOL = 'tol',
  FONTE = 'fonte',
  GES = 'ges',
  ENVIRONMENT_NAME = 'CONSTANT_ENVIRONMENT_NAME',
}
